var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-n5",attrs:{"data-aos":"fade-up"}},[_c('top-hero'),_c('announcement'),_c('want-to-know-more'),_c('get-on-the-move')],1)}
var staticRenderFns = []

export { render, staticRenderFns }